module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_13.79a7aa58.pdf";